import { FormValue, useFieldState } from 'informed'
import { useEffect, useState } from 'react'

const useNonSpammyFieldState = <V extends unknown = FormValue>(
  field: string,
) => {
  // If the field is a part of this component's children, useFieldState will
  // throw a warning on the initial render:
  // `Attempting to get field {name} but it does not exist`.
  // This is because this hook is called before this component's children's are,
  // so they haven't had time to register yet. After registering, this will
  // re-render and the warning will not reappear.
  // Because we **hate** useless warnings, we disable warnings on the initial
  // render.
  const [isInitialRender, setIsInitialRender] = useState(true)
  useEffect(() => {
    setIsInitialRender(false)
  }, [])
  const warn = console.warn
  if (isInitialRender) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    console.warn = () => {}
  }
  const fieldState = useFieldState<V>(field)
  if (isInitialRender) {
    console.warn = warn
  }

  return fieldState
}

export default useNonSpammyFieldState
